export default __webpack_public_path__ + "static/media/Flag_of_Bulgaria.70f96132.svg";